import {gearCollection} from '@/constants/gearList'

const genGearLink = (gearId) => `[${gearCollection[gearId].name}](GEAR:${gearId})`

export default genGearLink
